/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamInvitationSummary } from './TeamInvitationSummary';
import {
    TeamInvitationSummaryFromJSON,
    TeamInvitationSummaryFromJSONTyped,
    TeamInvitationSummaryToJSON,
    TeamInvitationSummaryToJSONTyped,
} from './TeamInvitationSummary';

/**
 * Result of inviting a team member
 * @export
 * @interface TeamInvitationResponse
 */
export interface TeamInvitationResponse {
    /**
     * 
     * @type {TeamInvitationSummary}
     * @memberof TeamInvitationResponse
     */
    invitation: TeamInvitationSummary;
    /**
     * 
     * @type {string}
     * @memberof TeamInvitationResponse
     */
    message: string;
}

/**
 * Check if a given object implements the TeamInvitationResponse interface.
 */
export function instanceOfTeamInvitationResponse(value: object): value is TeamInvitationResponse {
    if (!('invitation' in value) || value['invitation'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function TeamInvitationResponseFromJSON(json: any): TeamInvitationResponse {
    return TeamInvitationResponseFromJSONTyped(json, false);
}

export function TeamInvitationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamInvitationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invitation': TeamInvitationSummaryFromJSON(json['invitation']),
        'message': json['message'],
    };
}

export function TeamInvitationResponseToJSON(json: any): TeamInvitationResponse {
    return TeamInvitationResponseToJSONTyped(json, false);
}

export function TeamInvitationResponseToJSONTyped(value?: TeamInvitationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invitation': TeamInvitationSummaryToJSON(value['invitation']),
        'message': value['message'],
    };
}

